import { environment } from '@environments/environment';

export const BASE_APIGEE_URL = `${environment.APIGEE_HOST_EXTERNAL}`;
export const GIS_URL_PATH = 'product-pricing/locationlookup/v1';
